import { Reveal, Eyebrow } from "./Reveal";
import { ABOUT_IMG } from "../../data/site";
import { useLang } from "../../i18n/LanguageContext";

export const About = () => {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-36 bg-background"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 grid md:grid-cols-12 gap-12 md:gap-16 items-center">
        <div className="md:col-span-6 lg:col-span-5">
          <Reveal>
            <Eyebrow>{t.about.eyebrow}</Eyebrow>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl mt-6 leading-tight">
              {t.about.title}
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-muted-foreground text-base md:text-lg max-w-md font-light leading-relaxed">
              {t.about.p1}
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-5 text-muted-foreground text-base md:text-lg max-w-md font-light leading-relaxed">
              {t.about.p2}
            </p>
          </Reveal>
          <Reveal delay={0.35}>
            <div className="mt-10 flex gap-12">
              <div>
                <div className="font-serif text-4xl md:text-5xl text-primary">12</div>
                <div className="text-xs uppercase tracking-luxe text-muted-foreground mt-2">
                  {t.about.stat1}
                </div>
              </div>
              <div>
                <div className="font-serif text-4xl md:text-5xl text-primary">∞</div>
                <div className="text-xs uppercase tracking-luxe text-muted-foreground mt-2">
                  {t.about.stat2}
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="md:col-span-6 lg:col-span-7">
          <Reveal y={40} className="overflow-hidden">
            <img
              data-testid="about-image"
              src={ABOUT_IMG}
              alt="Relaxing by the sea at Tribe Beach Lounge, Tigaki beach, Kos"
              className="w-full h-[420px] md:h-[620px] object-cover hover:scale-105 transition-transform duration-700"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
